import { EVENT_ROUTE_CHANGE } from '@grafana/faro-web-sdk';
import { api } from '../../dependencies';
export let activeEvent = undefined;
export function createNewActiveEvent(url) {
    activeEvent = {
        route: '',
        url,
    };
    return activeEvent;
}
export function setActiveEventRoute(route) {
    if (activeEvent) {
        activeEvent.route = route;
    }
}
export function sendActiveEvent() {
    api.pushEvent(EVENT_ROUTE_CHANGE, activeEvent, undefined, { skipDedupe: true });
    activeEvent = undefined;
}
//# sourceMappingURL=activeEvent.js.map